import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import * as XLSX from 'xlsx-js-style';
import { handleGetRequest } from '../../service/GetTemplate';
import { endPoints } from '../../Config';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { handlePostRequest } from '../../service/PostTemplate';
import { useNavigate } from 'react-router-dom';

const Tickets = () => {
        const permissionsList = useSelector((state) => state?.pagePermissions?.permissions || []);

    const [ticketData, setTicketData] = useState([]);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [ticketTypes, setTicketTypes] = useState([]);
    const [ticketStatus, setTicketStatus] = useState([]);

    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        startDate: Yup.date().nullable(),

        endDate: Yup.date().when('startDate', {
            is: (startDate) => !!startDate,
            then: Yup.date().required('Date To is required').min(Yup.ref('startDate'), 'Date To has to be more than Date From')
        })
    });
    const dispatch = useDispatch();
    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            ticketTypeId: '',
            ticketStatusId: '',
            ticketId: '',
            startDate: '',
            endDate: '',
            pageNumber: 1,
            pageSize: 15,
            merchantId: ''
        },
        validate: (data) => {
            let errors = {};

            if (data.endDate && !data.startDate) {
                errors.startDate = 'Date From is required when Date To is provided';
            }

            if (data.startDate && data.endDate && data.startDate > data.endDate) {
                errors.endDate = 'Date To must be greater than or equal to Date From';
            }

            return errors;
        },
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const mercahntId = user?.data?.merchantId;
            setLoadingBtn(true);
            const postData = {
                ticketTypeId: data.ticketTypeId === '' ? null : data.ticketTypeId,
                ticketStatusId: data.ticketStatusId === '' ? null : data.ticketStatusId,
                ticketId: data.ticketId === '' ? null : data.ticketId,
                startDate: data.startDate === '' ? null : data.startDate,
                endDate: data.endDate === '' ? null : data.endDate,
                pageNumber: data.pageNumber === '' ? null : data.pageNumber,
                pageSize: data.pageSize === '' ? null : data.pageSize,
                merchantId: mercahntId
            };

            const response = await dispatch(handlePostRequest(postData, endPoints.getAllTicket, true));
            if (response?.status === 200) {
                setTicketData(response?.data?.data?.data);
            }
            setLoadingBtn(false);
        }
    });
    const orderDateTemplate = (rowData) => {
        const isoDate = rowData?.order_Date;
        const date = new Date(isoDate);

        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const yyyy = date.getFullYear();

        const formattedDate = `${dd}/${mm}/${yyyy}`;
        return <p>{formattedDate}</p>;
    };
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const previousDate = currentDate.toISOString().split('T')[0];

    const exportToExcel = () => {
        if (!ticketData || ticketData.length === 0) return;

        const exportData = ticketData.map((item, index) => ({
            'Sr #': index + 1,
            'Basket ID': item.basket_Id,
            'Order Date': new Date(item.order_Date).toLocaleDateString(),
            'Payment Name': item.paymentName,
            Amount: item.amount,
            'Transaction Currency': item.transaction_Currency,
            'Issuer Name': item.issuer_Name,
            'Masked Pan': item.masked_Pan
        }));

        const worksheetData = [['Sr #', 'Basket ID', 'Order Date', 'Payment Name', 'Amount', 'Transaction Currency', 'Issuer Name', 'Masked Pan'], ...exportData.map((obj) => Object.values(obj))];

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
        for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
            if (!worksheet[cellAddress]) continue;
            worksheet[cellAddress].s = {
                font: { bold: true }
            };
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Reports');

        XLSX.writeFile(workbook, 'reports.xlsx');
    };
    const getTicketTypes = async () => {
        const response = await handleGetRequest(endPoints.getDropdownTicketsTypes, true, false, dispatch);
        if (response) {
            setTicketTypes(response?.data);
        }
    };
    const getTicketStatus = async () => {
        const response = await handleGetRequest(endPoints.getDropdownTicketsStatus, true, false, dispatch);
        if (response) {
            setTicketStatus(response?.data);
        }
    };

    useEffect(() => {
        getTicketTypes();
        getTicketStatus();
    }, []);

    const handleReset = (e) => {
        e.preventDefault();
        formik.resetForm();
    };

    const handleAdd = () => {
        navigate('/create-ticket');
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                                        {permissionsList?.updateAllowed === 'Y' && (

                    <Button tooltip="Edit" icon="pi pi-pencil" tooltipOptions={{ position: 'top' }} onClick={() => navigate('/edit-ticket', { state: { rowData } })} className="p-button-rounded p-button-primary mr-2 ml-2" />
                                        )}
                    {permissionsList?.viewAllowed === 'Y' && (

                    <Button tooltip="View" tooltipOptions={{ position: 'top' }} icon="pi pi-eye" onClick={() => navigate('/view-ticket', { state: { rowData } })} className="p-button-rounded" style={{ backgroundColor: '#F2AC57', border: 'none' }} />
                    )}
                </div>
            </>
        );
    };

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Ticket Management</h3>
                <div className="flex gap-2">
                    {permissionsList?.insertAllowed === 'Y' &&
                    <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" onClick={() => handleAdd()} />}
                </div>
            </div>
            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid grid mb-5">
                        {' '}
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="ticketStatusId">Status</label>
                                <Dropdown
                                    id="ticketStatusId"
                                    name="ticketStatusId"
                                    value={formik?.values?.ticketStatusId}
                                    options={ticketStatus}
                                    optionLabel="name"
                                    optionValue="id"
                                    onChange={formik.handleChange}
                                    placeholder="Select Status"
                                    className="w-full"
                                />
                                {formik.touched.ticketStatusId && formik.errors.ticketStatusId && <small className="p-error">{formik.errors.ticketStatusId}</small>}
                            </div>
                        </div>
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="ticketTypeId">Ticket Type</label>
                                <Dropdown
                                    id="ticketTypeId"
                                    name="ticketTypeId"
                                    value={formik?.values?.ticketTypeId}
                                    options={ticketTypes}
                                    optionLabel="name"
                                    optionValue="id"
                                    onChange={formik.handleChange}
                                    placeholder="Select Ticket Type"
                                    className="w-full"
                                />
                                {formik.touched.ticketTypeId && formik.errors.ticketTypeId && <small className="p-error">{formik.errors.ticketTypeId}</small>}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName">Start Date</label>
                                <InputText id="startDate" type="date" name="startDate" max={previousDate} value={formik?.values?.startDate || ''} onChange={formik.handleChange} />

                                {formik.touched.startDate && formik.errors.startDate && <small className="p-error">{formik.errors.startDate}</small>}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="endDate"> End Date </label>
                                <InputText id="endDate" type="date" name="endDate" max={previousDate} value={formik?.values?.endDate || ''} onChange={formik.handleChange} />

                                {formik.touched.endDate && formik.errors.endDate && <small className="p-error">{formik.errors.endDate}</small>}
                            </div>
                        </div>
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="ticketId">Ticket Id</label>
                                <InputText id="ticketId" name="ticketId" placeholder="Enter Ticket Id" maxLength={15} value={formik?.values?.ticketId} onChange={formik.handleChange} />
                                {formik.touched.ticketId && formik.errors.ticketId && <small className="p-error">{formik.errors.ticketId}</small>}
                            </div>
                        </div>
                        <div className="live__SearchBtn p-field col-12 md:col-12">
                            <Button label="Search" icon="pi pi-search" className="Btn__Dark__Search" type="submit" />

                            <Button label="Reset" onClick={(e) => handleReset(e)} className="Btn__Transparent__Reset" />
                        </div>
                    </div>
                </form>
            </div>
            <div className="Form__Header mt-5 flex justify-content-between flex-wrap">
                <p className="text-2xl font-medium"></p>
                <div className="flex align-items-center justify-content-center mb-2">
                    <Button className="mr-2" onClick={exportToExcel} disabled={!ticketData || ticketData.length === 0}>
                        Export To Excel
                    </Button>
                </div>
            </div>
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <DataTable
                            paginator
                            rows={formik.values.pageSize}
                            first={(formik.values.pageNumber - 1) * formik.values.pageSize}
                            onPage={(e) => {
                                formik.setFieldValue('pageSize', e.rows);
                                formik.setFieldValue('pageNumber', Math.floor(e.first / e.rows) + 1);
                                formik.handleSubmit(); // trigger search when page changes
                            }}
                            rowsPerPageOptions={[5, 10, 20]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                            emptyMessage="No List found."
                            responsiveLayout="scroll"
                            value={ticketData}
                            className="p-datatable-sm datatable-responsive"
                        >
                            <Column field="id" header="ID " />
                            <Column field="title" header="Title" />
                            <Column field="ticketType" header="Ticket Type" />
                            <Column field="ticketStatus" header="Ticket Status" />
                            <Column field="transactionId" header="Transaction ID" />
                            <Column header="Actions" body={actionBodyTemplate} className="Table__ActionHeading__CentredAlign" />
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Tickets;
